import React from 'react'
import './ButtonGroup.css'
import { ReactComponent as ArchIcon } from '@assets/images/arch.svg'
import { ReactComponent as QuadrantIcon } from '@assets/images/quadrant.svg'

interface ButtonGroupProps {
  buttons: {
    label: string
    value: string
    icon?: string
    svg?: string
    disabled?: boolean
  }[]
  activeTab?: string
  onButtonClick: (tab: string) => void
  className?: string
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  activeTab,
  onButtonClick,
  className,
}) => {
  const iconMap = {
    arch: ArchIcon,
    quadrant: QuadrantIcon,
  }

  return (
    <div className={`tab-button-group ${className}`}>
      {buttons.map(({ label, value, icon, svg, disabled }) => (
        <button
          key={value}
          type="button"
          className={`tab-button ${activeTab === value ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault()
            onButtonClick(value)
          }}
          disabled={disabled}
        >
          {icon && <span className={icon} />}
          {svg &&
            React.createElement(iconMap[svg as keyof typeof iconMap])}{' '}
          {label}
        </button>
      ))}
    </div>
  )
}

export default ButtonGroup
